import { currentLang } from '@/i18n'
export function isArray(o) {
  return Object.prototype.toString.call(o) === '[object Array]'
}

export const storageOptions = {
  namespace: 'sp__',
  name: 'ls',
  storage: 'local'
}

/**
 * 根据切换的语言设置输入框input的maxLength长度
 */
export const diffLength = function(length) {
  const numberReg = /^[0-9]+.?[0-9]*$/
  if (!length && !numberReg.test(length)) {
    return
  }
  const LANG = currentLang
  const langMap = {
    'zh-cn': 30,
    'es-mx': 30,
    // 'en-us': 30,
    'en-xa': 30,
    'ar-sa': 30
  }

  return langMap[LANG] * length
}



// WEBPACK FOOTER //
// ./src/lib/utils.js